/*
-------------------------------------------------------------------------------------
Authors         : Alinsonorin, John Myl B., Awi, Joseph Kahl L., Gozon, Daniel Allan
Date Created    : April 30, 2025
Folder          : src/components/homepage/index
File            : Homepage.tsx
Description     : 
    This component allows the user to access the homepage of the web app.
Copyright © 2025. All rights reserved.
-------------------------------------------------------------------------------------
*/




// Import MUI Components
import {
  Box
} from "@mui/material"

// Import Molecules
import Hero from "../../../molecules/body/hero/Hero"
import Section from "../../../molecules/body/index/Section.jsx"
import Insurance from "../../../molecules/body/insurance/Insurance.jsx"

const Body = () => {

  const boxStylesWrapper = {
    backgroundColor: "#FDF9F3",
    justifyContent: "center",
    alignItems: "center",
  }

  const boxStylesContent = {
    width: "100%",
    maxWidth: "1740px",
    margin: "0 auto",
    display: "flex",
    alignItems: "center",
    flexDirection: "column",
    justifyContent: "space-between",
    backgroundColor: "transparent",
    flex: 1 // allow content to grow and fill available height
  }
  
  return (
    <>
      <Box
        sx={boxStylesWrapper}
      >

        <Box
          sx={boxStylesContent}
        >

          <Hero
            index={true}
            title="Smile Bright"
            subtitle="Like a Diamond"/>

          <Section
            section="clinic"
            title="Our Clinic"
            subtitle="Wide range of services"
            destination="./about"/>

          <Section
            section="service"
            title="Our Services"
            subtitle="none"
            destination="./services"/>

          <Section
            section="team"
            title="Our Team"
            subtitle="none"
            destination="./about"/>

          <Insurance
            section="insurance"
            title="Accepted Insurance Providers"
            subtitle="We accept a wide range of insurance plans to make dental care accessible and affordable"/>
            
          <Section
            section="faqs"/>

        </Box>
      </Box>
    </>
  )

}

export default Body;